/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { SingleSelectDropDown } from '@insticator/insticator-ui';
import Header from '../../../../../material/structure/header/header';
// styles
import injectSheet from 'react-jss';
import styles from "./triviapollsheader_styles";

const TriviaPollsHeader = injectSheet(styles)((props) => {

  return (
    <div className={`triviapollsheader ${props.classes.triviapollsheader}`}>
      <Header>
        <>
        <SingleSelectDropDown 
          name={'All'} 
          title={'Sites'} 
          icon={'globe'} 
          disabled={true}
          items={[{name: 'All', value: 'All'}]}
        />
        </>
      </Header>
    </div>
  )
});

export default TriviaPollsHeader;
